import { Grid } from '@mui/material'
import React from 'react'
import CompleteHeader from '../components/complete-header'
import SuspendedPlan from '../components/plan-details/suspended-plan'
import StepPageContainer from '../components/step-page-container'
import SuspendCompletePanel from '../components/suspend-complete-panel'

const SuspensionCompletePage = ({ suspension }) => {
  return (
    <StepPageContainer>
      <Grid item xs={12}>
        <CompleteHeader title="You're all set - your suspension is scheduled" />
      </Grid>
      <Grid item xs={12} sm={12} md={6}>
        <SuspendCompletePanel suspension={suspension} />
      </Grid>
      <Grid item xs={12} sm={12} md={6}>
        <SuspendedPlan suspension={suspension} />
      </Grid>
    </StepPageContainer>
  )
}

export default SuspensionCompletePage
